export default "__VITE_ASSET__BsVnIrSU__"